import React from "react";
import styled, { css } from "styled-components";
import { PluginStore } from "graylog-web-plugin/plugin";
import { Button, Col, Row } from "components/bootstrap";
import { Card } from "components/common";
import { prepareDataTieringInitialValues, DataTieringVisualisation } from "components/indices/data-tiering";
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
const StyledCard = styled(Card)(
  ({ $selected, $disabled, theme }) => css`
    display: flex;
    gap: ${theme.spacings.sm};
    ${$disabled && `color: ${theme.colors.text.secondary};`}

    ${$selected && `
    background-color: ${theme.colors.global.background};
    border: 2px solid ${theme.colors.contrast.default};
  `}
  `
);
const Title = styled.h3(
  ({ $disabled, theme }) => css`
    ${$disabled && `color: ${theme.colors.text.secondary};`}
  `
);
const Description = styled.p`
  margin-bottom: 0;
`;
const IndexSetTemplateCard = ({ template, handleCardClick, isSelected }) => {
  const dataTieringConfig = prepareDataTieringInitialValues(template.index_set_config.data_tiering, PluginStore, false);
  return /* @__PURE__ */ React.createElement(StyledCard, { $selected: isSelected, $disabled: !template.enabled }, /* @__PURE__ */ React.createElement(Title, { $disabled: !template.enabled }, template.title), template.index_set_config.use_legacy_rotation && /* @__PURE__ */ React.createElement(Description, null, template.description), !template.index_set_config.use_legacy_rotation && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 8 }, /* @__PURE__ */ React.createElement(
    DataTieringVisualisation,
    {
      minDays: dataTieringConfig.index_lifetime_min,
      maxDays: dataTieringConfig.index_lifetime_max,
      minDaysInHot: dataTieringConfig.index_hot_lifetime_min,
      warmTierEnabled: dataTieringConfig.warm_tier_enabled,
      archiveData: dataTieringConfig.archive_before_deletion
    }
  )), /* @__PURE__ */ React.createElement(Col, { md: 4 }, /* @__PURE__ */ React.createElement(Description, null, template.description))), template.enabled && /* @__PURE__ */ React.createElement(ButtonWrapper, null, /* @__PURE__ */ React.createElement(Button, { onClick: () => handleCardClick(template), disabled: isSelected }, isSelected ? "Selected" : "Select")));
};
export default IndexSetTemplateCard;
